var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navbar Icon",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.835938 3.03633C0.835938 2.65167 1.14641 2.33984 1.52939 2.33984H13.0838C13.4668 2.33984 13.7772 2.65167 13.7772 3.03633V13.094C13.7772 13.4787 13.4668 13.7905 13.0838 13.7905H1.52939C1.14641 13.7905 0.835938 13.4787 0.835938 13.094V3.03633ZM2.22284 3.73282V12.3975H12.3903V3.73282H2.22284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3903 6.90469C12.3903 6.52003 12.7008 6.2082 13.0838 6.2082H16.1649C16.3489 6.2082 16.5252 6.28158 16.6553 6.4122L18.9662 8.7332C19.0962 8.86381 19.1693 9.04097 19.1693 9.22569V13.094C19.1693 13.4787 18.8588 13.7905 18.4758 13.7905L13.0838 13.7905C12.7008 13.7905 12.3903 13.4787 12.3903 13.094V6.90469ZM13.7772 7.60118V12.3975H17.7824V9.51419L15.8777 7.60118H13.7772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99566 13.7905C4.31509 13.7905 3.76338 14.3446 3.76338 15.0281C3.76338 15.7117 4.31509 16.2658 4.99566 16.2658C5.67623 16.2658 6.22794 15.7117 6.22794 15.0281C6.22794 14.3446 5.67623 13.7905 4.99566 13.7905ZM2.37648 15.0281C2.37648 13.5753 3.54912 12.3975 4.99566 12.3975C6.4422 12.3975 7.61484 13.5753 7.61484 15.0281C7.61484 16.481 6.4422 17.6588 4.99566 17.6588C3.54912 17.6588 2.37648 16.481 2.37648 15.0281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0095 13.7905C14.3289 13.7905 13.7772 14.3446 13.7772 15.0281C13.7772 15.7117 14.3289 16.2658 15.0095 16.2658C15.6901 16.2658 16.2418 15.7117 16.2418 15.0281C16.2418 14.3446 15.6901 13.7905 15.0095 13.7905ZM12.3903 15.0281C12.3903 13.5753 13.563 12.3975 15.0095 12.3975C16.456 12.3975 17.6287 13.5753 17.6287 15.0281C17.6287 16.481 16.456 17.6588 15.0095 17.6588C13.563 17.6588 12.3903 16.481 12.3903 15.0281Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.3fd8ea3b99903b9aefbe263270f19def.svg";
export { ForwardRef as ReactComponent };